<template>
  <div class="overview" :style="{background:'url('+$baseUrl+'img/dataBoard/bg.png)','background-size': 'auto 100%'}">
    <!-- 概况 -->
    <div>
      <el-row>
        <el-col :xl="{span:6}" :lg="{span:7}" :md="{span:9}" class="overview-left">
          <div class="left-serve">
            <p class="serve-title">服务概况</p>
            <!-- <ChooseDate :dateValue.sync="dateValue" :effect="'light'"/> -->
            <ChooseDateAndCustomer :showCustomer="true" :noWrap="false" @paramsInfo="receiveParamsInfo" :effect="'light'"/>
          </div>
          <div class="left-trend overview-box">
            <el-row class="serve-statistics" type="flex" justify="space-around">
              <el-col class="statistics-box">
                <p>{{durationInfo.durationSum}}</p>
                <p>服务时长 (分钟)</p>
              </el-col>
              <el-col class="statistics-box">
                <p>{{durationInfo.cntSum}}</p>
                <p>服务次数 (次)</p>
              </el-col>
            </el-row>
            <p>【 服务趋势 】</p>
            <div class="serve-statistics-line">
              <div style="width: 100%;height:100%;">
                <div v-if="JSON.stringify(durationByBusiScopeLine[0])==='[]'">
                  <p style="text-align: center;color: #fff;line-height: 135px;margin: 0;">暂无数据</p>
                </div>
                <LineChart v-else
                  :pageLight="'black'"
                  :lineDataProps="durationByBusiScopeLine"
                  :legendProps="legendProps"
                  :axisNameProps="{xName: lineChartXName,yName: ''}"/>
              </div>
            </div>
          </div>
          <div class="reg-ranking overview-box" style="position: relative;">
            <div v-if="summaryParmasInfo.customerId" style="position: absolute;top: 3px;right:3px;color: #fff;">
              <el-radio-group v-model="tabRankingList" size="mini" fill="#F28639">
                <el-radio-button label="region">地域</el-radio-button>
                <el-radio-button label="project">项目</el-radio-button>
              </el-radio-group>
            </div>
            <template v-if="tabRankingList==='region'">
              <p>【 服务地域排行榜 】</p>
              <TableForDownload
                :tableColumnsProps="busiScopeTabColumns"
                :tableDataProps="busiScopeTableProps"
                :textColor="'#fff'"
                :themeColor="{color:'#F28639',colorOpa: 'rgba(242, 134, 57, 0.2)'}" />
            </template>
            <template v-else>
              <p>【 服务项目排行榜 】</p>
              <TableForDownload
                :tableColumnsProps="customerProjectTabColumns"
                :tableDataProps="customerProjectRankingList"
                :textColor="'#fff'"
                :themeColor="{color:'#F28639',colorOpa: 'rgba(242, 134, 57, 0.2)'}" />
            </template>
          </div>
        </el-col>
        <el-col :xl="{span:12}" :lg="{span:10}" :md="{span:6}" class="overview-center">
          <el-row type="flex" justify="space-between" style="flex-wrap: wrap;padding: 0 10px;">
            <el-col :xl="{span:7}" :lg="{span:7}" :md="{span:11}" class="serve-total">
              <div class="top-line"></div>
              <el-row type="flex" justify="space-around" style="height:100%">
                <div>
                  <p>{{centerInfo.totalOrderDuration}}</p>
                  <p>累计服务时长（分钟）</p>
                </div>
                <div>
                  <i class="el-icon-time"></i>
                </div>
              </el-row>
            </el-col>
            <el-col :xl="{span:7}" :lg="{span:7}" :md="{span:11}" class="serve-total">
              <div class="top-line"></div>
              <el-row type="flex" justify="space-around" style="height:100%">
                <div>
                  <p>{{centerInfo.totalSnCnt}}</p>
                  <p>累计服务平台数（个）</p>
                </div>
                <div>
                  <i class="el-icon-cloudy"></i>
                </div>
              </el-row>
            </el-col>
            <el-col :xl="{span:7}" :lg="{span:7}" :md="{span:11}" class="serve-total">
              <div class="top-line"></div>
              <el-row type="flex" justify="space-around" style="height:100%">
                <div>
                  <p>{{centerInfo.totalCustomerCnt}}</p>
                  <p>累计服务企业数（个）</p>
                </div>
                <div>
                  <i class="el-icon-help"></i>
                </div>
              </el-row>
            </el-col>
          </el-row>
          <div class="overview-center-img">
            <el-image style="width: 100%; height: 100%" :src="$baseUrl+'img/dataBoard/industry.png'" fit="fill"></el-image>
          </div>
        </el-col>
        <el-col :xl="{span:6}" :lg="{span:7}" :md="{span:9}" class="overview-right">
          <div class="right-serve">
              <!-- <p class="serve-title">开发者概况</p> -->
              <p class="serve-title">用户概况</p>
              <ChooseDateAndCustomer :showCustomer="false" :noWrap="false" @paramsInfo="receiveCustomerParamsInfo" :effect="'light'"/>
              <!-- <ChooseDate :dateValue.sync="dateValueDevelop" :effect="'light'"/> -->
          </div>
          <div class="right-trend overview-box">
            <el-row class="serve-statistics" type="flex" justify="space-around">
              <div :class="{'statistics-box':true,'active':developActiveTab==='活跃用户'?true:false}" @click="developerLineChange('活跃用户')">
                <p>{{developerInfo.busiScopeSum}}</p>
                <p>活跃用户数量</p>
                <!-- <p>活跃企业数量</p> -->
              </div>
              <div :class="{'statistics-box':true,'active':developActiveTab==='活跃平台'?true:false}" @click="developerLineChange('活跃平台')">
                <p>{{developerInfo.snSum}}</p>
                <p>活跃平台数量</p>
              </div>
              <div :class="{'statistics-box':true,'active':developActiveTab==='新增企业'?true:false}" @click="developerLineChange('新增企业')">
                <p>{{developerInfo.busiScopeAddSum}}</p>
                <p>新增企业注册</p>
              </div>
              <div :class="{'statistics-box':true,'active':developActiveTab==='新增个人'?true:false}" @click="developerLineChange('新增个人')">
                <p>{{developerInfo.personalAddSum}}</p>
                <p>新增个人注册</p>
              </div>
            </el-row>
            <p>【 {{developActiveTab}}变化趋势 】</p>
            <div class="serve-statistics-line">
              <div v-if="JSON.stringify(developerActiveLine[0])==='[]'&&JSON.stringify(developerActiveLine[1])==='[]'">
                <p style="text-align: center;color: #fff;line-height: 135px;margin: 0;">暂无数据</p>
              </div>
              <LineChart v-else
                :lineDataProps="developerActiveLine"
                :axisNameProps="{xName: lineChartXNameDevelop,yName: '/数量'}"/>
            </div>
          </div>
           <div class="reg-ranking overview-box">
            <p>【 活跃用户排行榜 】</p>
            <TableForDownload
              :tableColumnsProps="personalTabColumns"
              :tableDataProps="personalTableDataProps"
              :textColor="'#fff'"
              :themeColor="{color:'#F4802C',colorOpa: 'rgba(242, 134, 57, 0.2)'}" />
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 底部导航条 -->
    <el-row class="overview-footer">
      <el-col :span="6" :class="activeMenu==='1'?'active':''" @click="changeMenu('1')"><p @click="changeMenu('1')">开发者分析</p></el-col>
      <el-col :span="6" :class="activeMenu==='2'?'active':''"><p @click="changeMenu('2')">终端分析</p></el-col>
      <el-col :span="6" :class="activeMenu==='3'?'active':''"><p @click="changeMenu('3')">产品分析</p></el-col>
      <el-col :span="6" :class="activeMenu==='4'?'active':''"><p @click="changeMenu('4')">运营分析</p></el-col>
    </el-row>
  </div>
</template>
<script>
// import ChooseDate from '../Components/chooseData.vue'
import ChooseDateAndCustomer from '../Components/chooseDataAndCustomer.vue'
import LineChart from '@/components/chartComponents/line.vue'
import TableForDownload from '../Components/tabeleFordownload.vue'
// import { getDay } from '@/utils/util'
export default {
  components: {
    // ChooseDate, // 日期选择
    LineChart,
    TableForDownload,
    ChooseDateAndCustomer
  },
  data() {
    return {
      dateValueDevelop:'today', //开发者概况日期
      lineChartXNameDevelop: '24小时',
      dateValue: 'today',//服务概况日期
      lineChartXName: '24小时',
      centerInfo: {
        totalOrderDuration: 0,
        totalSnCnt: 0,
        totalCustomerCnt: 0
      },
      activeMenu: '',
      legendProps:['服务时长', '服务次数'],
      durationByBusiScopeLine: [[]],
      busiScopeTableProps: [],
      durationInfo: {
        durationSum: 0,
        cntSum: 0
      },
      busiScopeTabColumns: [
        {key: '',label: '序号'},
        {key: 'type',label: '地域'},
        {key: 'cnt',label: '服务次数'},
      ],
      personalTabColumns: [
        {key: '',label: '排名'},
        {key: 'type',label: '用户'},
        {key: 'duration',label: '服务时长（分钟）'},
      ],
      customerProjectTabColumns: [
        {key: '',label: '序号'},
        {key: 'type',label: '项目'},
        {key: 'duration',label: '服务时长'},
      ],
      // **************************开发者概况
      developActiveTab: '活跃用户',
      developerActiveLine: [],
      busiScopeLine: [[],[]],//活跃企业数量
      snLine: [[],[]],//活跃平台数量
      busiScopeAddLine: [[],[]],//新增企业数量
      personalAddLine: [[],[]],//新增开发者数量
      developerInfo: {
        busiScopeSum: 0, //活跃用户数量
        snSum: 0,//活跃平台数量
        busiScopeAddSum: 0,//新增企业注册
        personalAddSum: 0,//新增开发者注册
      },
      personalTableDataProps: [],//活跃开发者排行
      // ****************************服务概况new
      summaryParmasInfo: {// 查询服务概况需要的查询参数
        statUnit: 'currentDay',
      },
      // ****************************用户概况new
      customerParmasInfo: {// 查询用户概况需要的查询参数
        statUnit: 'currentDay',
      },
      tabRankingList: 'region',
      customerProjectRankingList: [], // 选择用户下的项目使用排行榜
    }
  },
  watch: {
    'summaryParmasInfo': {
      handler(val) {
        this.resetDurationData();
        this.getSummaryDatasNew(); //服务概况
        this.getAreaDurationTopNew(); //服务地域排行榜
        if(val.statUnit==='day' || val.statUnit==='currentDay') this.lineChartXName = '日';
        if(val.statUnit==='month') this.lineChartXName = '月';
        if(val.statUnit==='year') this.lineChartXName = '年';

        if(!val.customerId) this.tabRankingList='region';

      },
      immediate: true,
      deep: true
    },
    'customerParmasInfo': {
      handler(val) {
        this.resetDevelopData();
        this.getCustomerSummary();// 获取用户概况

        if(val.statUnit==='day' || val.statUnit==='currentDay') this.lineChartXNameDevelop = '日';
        if(val.statUnit==='month') this.lineChartXNameDevelop = '月';
        if(val.statUnit==='year') this.lineChartXNameDevelop = '年';

        // if(val==='today') {
        //   this.getDevelopTodayDatasByCustomer();
        //   this.getTodayTopDatasByCustomer();
        // }else if(val==='week'||val==='month'||val==='year') {
        //   if(val==='week') this.lineChartXNameDevelop = '7天';
        //   if(val==='month') this.lineChartXNameDevelop = '日期';
        //   if(val==='year') this.lineChartXNameDevelop = '12月';
        //   this.getDevelopHiestoryDatasByCustomer();
        //   this.getHistoryTopDatasByCustomer();
        // }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
  //   this.getAreaDurationTop();
  //   this.getDevelopTodayDatasByCustomer();
  //   this.getTodayTopDatasByCustomer();
  //   this.getOrderCntAndDuration();// 数据总体统计
  //   this.getSummaryDatas();//服务时长、服务次数折线图
  },
  methods: {
    // 接收服务概况查询参数
    receiveParamsInfo(val) {
      console.log(val)
      this.summaryParmasInfo = val;
      // this.getSummaryDatasNew();
    },
    // 接收用户概况查询参数
    receiveCustomerParamsInfo(val) {
      console.log(val)
      this.customerParmasInfo = val;
      // this.getCustomerSummary();
    },
    // 数据总体统计-天、周、月、年
    // getOrderCntAndDuration() {
    //   let params = {
    //     type: this.dateValue===''||this.dateValue==='today'? 'day' :this.dateValue
    //   }
    //   this.getRequest("/dev/system/dvw/taskOrder/getSummaryDatas", params).then(res => {
    //     if(res.status===200 && res.data.code ===1000) {
    //       let data = res.data.result;
    //       this.centerInfo = {
    //         totalOrderDuration: data.totalOrderDuration,
    //         totalSnCnt:  data.totalSnCnt,
    //         totalCustomerCnt:  data.totalCustomerCnt
    //       }
    //     }
    //   })
    // },
    // 服务概况-new
    getSummaryDatasNew() {
      let params = {
        ...this.summaryParmasInfo
      }
      this.getRequest("/dev/system/dvw/taskOrder/getOrderSummary",params).then(res => {
        if(res.status===200 && res.data.code ===1000) {
          let data = res.data.result;
          let orderDurationList=[],orderCntList=[],xLabelList=[];
          // 累计的时长、平台数、企业数
          this.centerInfo = {
            totalOrderDuration: data.totalOrderDuration,
            totalSnCnt:  data.totalSnCnt,
            totalCustomerCnt:  data.totalCustomerCnt
          }
          // 服务次数、服务时长
          this.durationInfo = {
              durationSum: data.orderSummary[0].duration || '0',
              cntSum: data.orderSummary[0].cnt || '0'
          }

          if(data.orderSummaryList.length>0) {
            data.orderSummaryList.map(item => {
              xLabelList.push(item.type);
              orderCntList.push(item.cnt);
              orderDurationList.push(item.duration);
            })
            let myset = new Set(xLabelList);
            for(var val of myset){
                this.durationByBusiScopeLine[0].push(val);
            }
            this.durationByBusiScopeLine.push({
              name: '服务时长',
              type: 'line',
              data: orderDurationList
            })
            this.durationByBusiScopeLine.push({
              name: '服务次数',
              type: 'line',
              data: orderCntList
            })
          }
          // 选择用户下的项目使用排行榜
          // if(data.customerOrderDurationTop10.length > 0) {
            this.customerProjectRankingList = data.customerOrderDurationTop10
          // }

        }
      })
    },
    // 服务地域排行榜-new
    getAreaDurationTopNew() {
      let params = {
        ...this.summaryParmasInfo
      }
      this.getRequest('/dev/system/dvw/clientInfo/getTopRegionSummary', params).then(res => {
        if(res.status===200 && res.data.code ===1000) {
          let data = res.data.result;
           this.busiScopeTableProps = data.topRegionSummary.length > 10 ? data.topRegionSummary.splice(0,10) : data.topRegionSummary;
        }
      })
    },
    // 用户概况-new
    getCustomerSummary() {
      let params = {
        ...this.customerParmasInfo
      }
       this.getRequest("/dev/system/dvw/taskOrder/getCustomerSummary", params).then(res => {
        if(res.status===200 && res.data.code ===1000) {
          let data = res.data.result;
          this.developerInfo = {
            snSum: data.activeSnCnt,//活跃平台数量
            busiScopeSum: data.activeCustomerCnt, //活跃用户数量
            busiScopeAddSum: data.increaseCompanyCnt,//新增企业数
            personalAddSum: data.increaseDeveloperCnt,//新增开发者注册
          }

          // 活跃平台变化趋势
          data.activeSnCntList.map(item => {
            this.snLine[0].push(item.type);
            this.snLine[1].push(item.cnt);
          })

          // 新增企业变化趋势
          data.increaseCompanyCntList.map(item => {
            this.busiScopeAddLine[0].push(item.type);
            this.busiScopeAddLine[1].push(item.cnt);
          })

          // 新增开发者变化趋势
          data.increaseDeveloperCntList.map(item => {
            this.personalAddLine[0].push(item.type);
            this.personalAddLine[1].push(item.cnt);
          })

          // 活跃用户变化趋势
          data.activeCustomerCntList.map(item => {
            this.busiScopeLine[0].push(item.type);
            this.busiScopeLine[1].push(item.cnt);
          })

          // 活跃用户排行榜top10
          this.personalTableDataProps = data.customerOrderDurationTop10;

          this.developerActiveLine = this.busiScopeLine;//默认展示活跃用户数量折线图
        }
      })
    },

    // 服务概况-天、周、月、年
    // getSummaryDatas() {
    //   let params = {
    //     type: this.dateValue===''||this.dateValue==='today'? 'day' :this.dateValue
    //   }
    //   this.getRequest("/dev/system/dvw/taskOrder/getOrderCntAndDuration",params).then(res=>{
    //     if(res.status===200 && res.data.code ===1000) {
    //       let data = res.data.result;
    //       let orderDurationList=[],orderCntList=[],xLabelList=[];
    //       if(this.dateValue==='today') {
    //       console.log(data)
    //         this.durationInfo = {
    //           durationSum: data.todayOrderDuration,
    //           cntSum: data.todayOrderCnt
    //         }
    //         data.hours24OrderDuration.map(item => {
    //           xLabelList.push(item.type);
    //           orderDurationList.push(item.duration)
    //         })
    //         data.hours24OrderCnt.map(item => {
    //           xLabelList.push(item.type);
    //           orderCntList.push(item.cnt)
    //         })
    //       }
    //       if(this.dateValue==='week') {
    //         // 服务概况-》服务趋势
    //         this.durationInfo = {
    //           durationSum: data.weekOrderDuration,
    //           cntSum: data.weekOrderCnt
    //         }
    //         data.days7OrderDuration.map(item => {
    //           xLabelList.push(item.type);
    //           orderDurationList.push(item.duration)
    //         })
    //         data.days7OrderCnt.map(item => {
    //           xLabelList.push(item.type);
    //           orderCntList.push(item.cnt)
    //         })
    //       }
    //       if(this.dateValue==='month') {
    //         // 服务概况-》服务趋势
    //         this.durationInfo = {
    //           durationSum: data.monthOrderDuration,
    //           cntSum: data.monthOrderCnt
    //         }
    //         data.days30OrderDuration.map(item => {
    //           xLabelList.push(item.type);
    //           orderDurationList.push(item.duration)
    //         })
    //         data.days30OrderCnt.map(item => {
    //           xLabelList.push(item.type);
    //           orderCntList.push(item.cnt)
    //         })
    //       }
    //       if(this.dateValue==='year') {
    //         // 服务概况-》服务趋势
    //         this.durationInfo = {
    //           durationSum: data.yearOrderDuration,
    //           cntSum: data.yearOrderCnt
    //         }
    //         data.months12OrderDuration.map(item => {
    //           xLabelList.push(item.type);
    //           orderDurationList.push(item.duration)
    //         })
    //         data.months12OrderCnt.map(item => {
    //           xLabelList.push(item.type);
    //           orderCntList.push(item.cnt)
    //         })
    //       }
    //       let myset = new Set(xLabelList);
    //       for(var val of myset){
    //           this.durationByBusiScopeLine[0].push(val);
    //       }
    //       this.durationByBusiScopeLine.push({
    //         name: '服务时长',
    //         type: 'line',
    //         data: orderDurationList
    //       })
    //       this.durationByBusiScopeLine.push({
    //         name: '服务次数',
    //         type: 'line',
    //         data: orderCntList
    //       })

    //     }
    //   })
    // },
    // **************************当天*******************************************
    // 服务概况-服务地域排行榜-当天
    // getAreaDurationTop() {
    //   this.getRequest('/dev/system/dvw/client/today/analysis').then(res => {
    //     if(res.status===200 && res.data.code ===1000) {
    //       let data = res.data.result;
    //       data.todayTopClientDurationRegionInfo.map((item,index) => {
    //         // 取前十个排名
    //         if(index<10) {
    //           this.busiScopeTableProps.push(item);
    //         }
    //       })
    //     }
    //   })
    // },
    // 开发者概况-当天
    // getDevelopTodayDatasByCustomer() {
      // this.getRequest("/dev/system/dvw/taskOrder/getTodayDatasByCustomer").then(res => {
      //   if(res.status===200 && res.data.code ===1000) {
      //     let data = res.data.result;
      //     let busiScopeSum= 0; //活跃企业数量
      //     let snSum= 0;//活跃平台数量
      //     let busiScopeAddSum= 0;//新增企业注册
      //     let personalAddSum= 0;//新增个人注册
      //     // 开发者概况-》活跃企业数量

      //     data.hours24ActiveCompanyCustomerCnt.map(item => {
      //       if(busiScopeSum <  Number(item.cnt)){
      //         busiScopeSum = Number(item.cnt);
      //       }
      //       this.busiScopeLine[0].push(item.type);
      //       this.busiScopeLine[1].push(item.cnt);
      //     })
      //     // 开发者概况-》活跃平台数量
      //     data.hours24ActiveCompanySnCnt.map(item => {
      //       if(snSum <  Number(item.cnt)){
      //         snSum = Number(item.cnt);
      //       }
      //       this.snLine[0].push(item.type);
      //       this.snLine[1].push(item.cnt);
      //     })
      //     // 开发者概况-新增企业数量
      //     data.hours24IncreaseCompanyCustomerCnt.map(item => {
      //       busiScopeAddSum = this.cal.add(busiScopeAddSum,Number(item.cnt));
      //       this.busiScopeAddLine[0].push(item.type);
      //       this.busiScopeAddLine[1].push(item.cnt);
      //     })
      //     // 开发者概况-新增个人数量
      //     data.hours24IncreasePersonalCustomerCnt.map(item => {
      //       personalAddSum = this.cal.add(personalAddSum,Number(item.cnt));
      //       this.personalAddLine[0].push(item.type);
      //       this.personalAddLine[1].push(item.cnt);
      //     })
      //     this.developerInfo = {
      //       busiScopeSum: busiScopeSum, //活跃企业数量
      //       snSum: snSum,//活跃平台数量
      //       busiScopeAddSum: busiScopeAddSum,//新增企业注册
      //       personalAddSum: personalAddSum,//新增个人注册
      //     }
      //     this.developerActiveLine = this.busiScopeLine;//默认展示活跃企业数量折线图
      //   }
      // })
    // },
    // 开发者概况-排行榜-当天
    // getTodayTopDatasByCustomer() {
    //   this.getRequest('/dev/system/dvw/taskOrder/getTodayTopDatasByCustomer').then(res => {
    //     if(res.status===200 && res.data.code ===1000) {
    //       let data = res.data.result;
    //       this.personalTableDataProps = data.todayPersonalOrderDurationTop10;
    //     }
    //   })
    // },
    // **************************周、月、年*******************************************

    // 服务概况-服务地域排行榜-周、月、年
    // getHistoryAreaDurationTop() {
    //   let params = {
    //     type: this.dateValue
    //   }
    //   this.getRequest('/dev/system/dvw/client/history/analysis',params).then(res => {
    //     if(res.status===200 && res.data.code ===1000) {
    //       let data = res.data.result;
    //       if(this.dateValue==='week') {
    //         data.weekTopClientDurationRegionInfo.map((item,index) => {
    //           // 取前十个排名
    //           if(index<10) {
    //             this.busiScopeTableProps.push(item)
    //           }
    //         })
    //       }
    //       if(this.dateValue==='month') {
    //         data.monthTopClientDurationRegionInfo.map((item,index) => {
    //           // 取前十个排名
    //           if(index<10) {
    //             this.busiScopeTableProps.push(item)
    //           }
    //         })
    //       }
    //       if(this.dateValue==='year') {
    //         data.yearTopClientDurationRegionInfo.map((item,index) => {
    //           // 取前十个排名
    //           if(index<10) {
    //             this.busiScopeTableProps.push(item)
    //           }
    //         })
    //       }

    //     }
    //   })
    // },
    // 开发者概况-周、月、年
    // getDevelopHiestoryDatasByCustomer() {
    //   let params = {
    //     type: this.dateValueDevelop
    //   }
    //   this.getRequest("/dev/system/dvw/taskOrder/getHistoryDatasByCustomer",params).then(res => {
    //     if(res.status===200 && res.data.code ===1000) {
    //       let data = res.data.result;
    //       if(this.dateValueDevelop==='week') {
    //         let busiScopeSum= 0; //活跃企业数量
    //         let snSum= 0;//活跃平台数量
    //         let busiScopeAddSum= 0;//新增企业注册
    //         let personalAddSum= 0;//新增个人注册
    //         // 开发者概况-》活跃企业数量
    //         data.week7ActiveCompanyCustomerCnt.map(item => {
    //           if(busiScopeSum <  Number(item.cnt)){
    //             busiScopeSum = Number(item.cnt);
    //           }
    //           this.busiScopeLine[0].push(item.type);
    //           this.busiScopeLine[1].push(item.cnt);
    //         })
    //         // 开发者概况-》活跃平台数量
    //         data.week7ActiveCompanySnCnt.map(item => {
    //           if(snSum <  Number(item.cnt)){
    //             snSum = Number(item.cnt);
    //           }
    //           this.snLine[0].push(item.type);
    //           this.snLine[1].push(item.cnt);
    //         })
    //         // 开发者概况-新增企业数量
    //         data.week7IncreaseCompanyCustomerCnt.map(item => {
    //           busiScopeAddSum = this.cal.add(busiScopeAddSum,Number(item.cnt));
    //           this.busiScopeAddLine[0].push(item.type);
    //           this.busiScopeAddLine[1].push(item.cnt);
    //         })
    //         // 开发者概况-新增个人数量
    //         data.week7IncreasePersonalCustomerCnt.map(item => {
    //           personalAddSum = this.cal.add(personalAddSum,Number(item.cnt));
    //           this.personalAddLine[0].push(item.type);
    //           this.personalAddLine[1].push(item.cnt);
    //         })
    //         this.developerInfo = {
    //           busiScopeSum: busiScopeSum, //活跃企业数量
    //           snSum: snSum,//活跃平台数量
    //           busiScopeAddSum: busiScopeAddSum,//新增企业注册
    //           personalAddSum: personalAddSum,//新增个人注册
    //         }
    //         this.developerActiveLine = this.busiScopeLine;//默认展示活跃企业数量折线图
    //       }
    //       if(this.dateValueDevelop==='month') {
    //         let busiScopeSum= 0; //活跃企业数量
    //         let snSum= 0;//活跃平台数量
    //         let busiScopeAddSum= 0;//新增企业注册
    //         let personalAddSum= 0;//新增个人注册
    //         // 开发者概况-》活跃企业数量
    //         data.month30ActiveCompanyCustomerCnt.map(item => {
    //           if(busiScopeSum <  Number(item.cnt)){
    //             busiScopeSum = Number(item.cnt);
    //           }
    //           this.busiScopeLine[0].push(item.type);
    //           this.busiScopeLine[1].push(item.cnt);
    //         })
    //         // 开发者概况-》活跃平台数量
    //         data.month30ActiveCompanySnCnt.map(item => {
    //           if(snSum <  Number(item.cnt)){
    //             snSum = Number(item.cnt);
    //           }
    //           this.snLine[0].push(item.type);
    //           this.snLine[1].push(item.cnt);
    //         })
    //         // 开发者概况-新增企业数量
    //         data.month30IncreaseCompanyCustomerCnt.map(item => {
    //           busiScopeAddSum = this.cal.add(busiScopeAddSum,Number(item.cnt));
    //           this.busiScopeAddLine[0].push(item.type);
    //           this.busiScopeAddLine[1].push(item.cnt);
    //         })
    //         // 开发者概况-新增个人数量
    //         data.month30IncreasePersonalCustomerCnt.map(item => {
    //           personalAddSum = this.cal.add(personalAddSum,Number(item.cnt));
    //           this.personalAddLine[0].push(item.type);
    //           this.personalAddLine[1].push(item.cnt);
    //         })
    //         this.developerInfo = {
    //           busiScopeSum: busiScopeSum, //活跃企业数量
    //           snSum: snSum,//活跃平台数量
    //           busiScopeAddSum: busiScopeAddSum,//新增企业注册
    //           personalAddSum: personalAddSum,//新增个人注册
    //         }
    //         this.developerActiveLine = this.busiScopeLine;//默认展示活跃企业数量折线图

    //       }
    //       if(this.dateValueDevelop==='year') {
    //         let busiScopeSum= 0; //活跃企业数量
    //         let snSum= 0;//活跃平台数量
    //         let busiScopeAddSum= 0;//新增企业注册
    //         let personalAddSum= 0;//新增个人注册
    //         // 开发者概况-》活跃企业数量
    //         if(data.year12ActiveCompanyCustomerCnt) data.year12ActiveCompanyCustomerCnt.map(item => {
    //           if(busiScopeSum <  Number(item.cnt)){
    //             busiScopeSum = Number(item.cnt);
    //           }
    //           this.busiScopeLine[0].push(item.type);
    //           this.busiScopeLine[1].push(item.cnt);
    //         })
    //         // 开发者概况-》活跃平台数量
    //         if(data.year12ActiveCompanySnCnt) data.year12ActiveCompanySnCnt.map(item => {
    //           if(snSum <  Number(item.cnt)){
    //             snSum = Number(item.cnt);
    //           }
    //           this.snLine[0].push(item.type);
    //           this.snLine[1].push(item.cnt);
    //         })
    //         // 开发者概况-新增企业数量
    //         if(data.year12IncreaseCompanyCustomerCnt) data.year12IncreaseCompanyCustomerCnt.map(item => {
    //           busiScopeAddSum = this.cal.add(busiScopeAddSum,Number(item.cnt));
    //           this.busiScopeAddLine[0].push(item.type);
    //           this.busiScopeAddLine[1].push(item.cnt);
    //         })
    //         // 开发者概况-新增个人数量
    //         if(data.year12IncreasePersonalCustomerCnt) data.year12IncreasePersonalCustomerCnt.map(item => {
    //           personalAddSum = this.cal.add(personalAddSum,Number(item.cnt));
    //           this.personalAddLine[0].push(item.type);
    //           this.personalAddLine[1].push(item.cnt);
    //         })
    //         this.developerInfo = {
    //           busiScopeSum: busiScopeSum, //活跃企业数量
    //           snSum: snSum,//活跃平台数量
    //           busiScopeAddSum: busiScopeAddSum,//新增企业注册
    //           personalAddSum: personalAddSum,//新增个人注册
    //         }
    //         this.developerActiveLine = this.busiScopeLine;//默认展示活跃企业数量折线图

    //       }
    //     }
    //   })
    // },
    // 开发者概况-排行榜-周、月、年
    // getHistoryTopDatasByCustomer() {
    //   let params = {
    //     type: this.dateValueDevelop
    //   }
    //   this.getRequest('/dev/system/dvw/taskOrder/getHistoryTopDatasByCustomer',params).then(res => {
    //      if(res.status===200 && res.data.code ===1000) {
    //       let data = res.data.result;
    //       if(this.dateValueDevelop==='week') {
    //         this.personalTableDataProps = data.weekPersonalOrderDurationTop10;
    //       }
    //       if(this.dateValueDevelop==='month') {
    //         this.personalTableDataProps = data.monthPersonalOrderDurationTop10;
    //       }
    //       if(this.dateValueDevelop==='year') {
    //         this.personalTableDataProps = data.yearPersonalOrderDurationTop10;
    //       }
    //     }
    //   })
    // },
    // 重置-服务概况数据
    resetDurationData() {
      this.durationByBusiScopeLine=  [[]];
      this.busiScopeTableProps = [];
      this.customerProjectRankingList = []; // 选择用户下的项目使用排行榜
      this.durationInfo = {
        durationSum: 0,
        cntSum: 0
      };
      this.centerInfo = {
        totalOrderDuration: 0,
        totalSnCnt: 0,
        totalCustomerCnt: 0
      }
    },
    // 重置-开发者概况数据
    resetDevelopData() {
      this.developActiveTab = '活跃用户';
      this.developerActiveLine = [];
      this.busiScopeLine = [[],[]];//活跃企业数量
      this.snLine = [[],[]];//活跃平台数量
      this.busiScopeAddLine = [[],[]];//新增企业数量
      this.personalAddLine = [[],[]];//新增开发者数量
      this.developerInfo = {
        busiScopeSum: 0, //活跃企业数量
        snSum: 0,//活跃平台数量
        busiScopeAddSum: 0,//新增企业注册
        personalAddSum: 0,//新增个人注册
      };
      this.personalTableDataProps = [];//活跃开发者排行
      this.tabRankingList = 'region';
    },
    developerLineChange(val) {
      this.developActiveTab = val;
      if(val==='活跃用户') this.developerActiveLine = this.busiScopeLine;
      if(val==='活跃平台') this.developerActiveLine = this.snLine;
      if(val==='新增企业') this.developerActiveLine = this.busiScopeAddLine;
      if(val==='新增个人') this.developerActiveLine = this.personalAddLine;
    },
    changeMenu(v) {
      this.activeMenu = v;
      if(v==='1') {
        this.$router.push('/dataBoard/developer');
      } else if(v==='2') {
        this.$router.push('/dataBoard/terminal');
      } else if(v==='3') {
        this.$router.push('/dataBoard/product');
      } else if(v==='4') {
        this.$router.push('/dataBoard/operations');
      }
    }
  }
}

</script>
<style lang='scss' scoped>
 .overview {
   width: 100%;
   height: 100%;
   padding: 20px 20px 0 20px;
   box-sizing: border-box;
   position: relative;
   &-left {
    //  min-width: 390px;
     .left-serve {
        width: 100%;
        min-height: 74px;
        padding: 10px;
        box-sizing: border-box;
        background: linear-gradient(0deg, rgba(242, 134, 57, 0.3) 0%, rgba(65, 0, 153, 0) 100%);
        border-radius: 5px;
        .serve-title {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #F28639;
          margin: 0;
          margin-bottom: 10px;
        }
     }
    .left-trend {
      >p {
        color:#F5A871;
        text-align: center;
        margin: 0;
      }
      .serve-statistics {
        .statistics-box {
          background: rgba(242, 134, 57, 1);
          padding: 10px 0;
          min-width: 130px;
          margin: 20px 30px;
          border-radius: 2px;
          >p:nth-of-type(1) {
            font-size: 20px;
          }
          >p:nth-of-type(2) {
            font-size: 12px;
          }
        }
        p {
          color: #fff;
          margin: 0;
          text-align: center;
        }
      }
      .serve-statistics-line {
        margin: 20px 30px;
        border: 1px dashed #ccc;
        width: calc(100% - 60px);
        height: 135px;
      }
    }
    .reg-ranking {
      padding: 0 20px;
      >p {
        color:#F5A871;
        text-align: center;
         margin-bottom: 5px;
      }
    }
   }
   &-center {
     >div:nth-of-type(1) {
        .serve-total {
          background: rgba(255, 107, 0, 0.2);
          min-width: 100px;
          margin-bottom: 10px;
          // min-width: 215px;
          // margin: 20px 30px;
          .top-line {
            width: 100%;
            height: 4px;
            background: #F4802C;
          }
          >div:nth-of-type(2) {
            >div:nth-of-type(1) {
              p {
                color: #fff;
                margin: 0;
                text-align: center;
              }
              >p:nth-of-type(1) {
                font-size: 24px;
                margin: 25px 0 10px 0;
              }
              >p:nth-of-type(2) {
                margin-bottom: 20px;
              }
            }
            >div:nth-of-type(2) {
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              i {
                font-size: 40px;
                font-weight: 600;
                color: #fff;
              }
            }
          }

       }
     }
     &-img {
       margin-top: 60px;
     }
   }
   &-right {
      // min-width: 390px;
     .right-serve {
        width: 100%;
        min-height: 74px;
        padding: 10px;
        box-sizing: border-box;
        background: linear-gradient(0deg, rgba(242, 134, 57, 0.3) 0%, rgba(15, 23, 24, 0) 100%);
        border-radius: 5px;
        .serve-title {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #F28639;
          margin: 0;
          margin-bottom: 10px;
        }
     }
     .right-trend {
      >p {
        color:#F5A871;
        text-align: center;
        margin: 0;
      }
      .serve-statistics {
        .statistics-box {
          background: rgba(242, 134, 57, 0.2);
          padding: 10px 0;
          min-width: 80px;
          margin: 20px 5px;
          cursor: pointer;
          border-radius: 2px;
          >p:nth-of-type(1) {
            font-size: 20px;
          }
          >p:nth-of-type(2) {
            font-size: 12px;
          }
        }
        .active {
          background:rgba(242, 134, 57, 1)
        }
        p {
          color: #fff;
          margin: 0;
          text-align: center;
        }
      }
      .serve-statistics-line {
        margin: 20px 30px;
        border: 1px dashed #ccc;
        width: calc(100% - 60px);
        height: 135px;
      }
    }
    .reg-ranking {
      padding: 0 20px;
      >p {
        color:#F5A871;
        text-align: center;
        margin-bottom: 5px;
      }
    }
   }
  //  边框
   &-box {
     border: 2px solid #F4802C4D;
     margin-top: 20px;
     border-radius: 5px;
   }
   &-footer{
     width: 100%;
     margin-left: -20px;
     height: 60px;
     background: rgba(65, 0, 153, 0.2);
     position: absolute;
     bottom: 0;
     >div {
       height: 60px;
       color: #fff;
       font-size: 20px;
       font-weight: 500;
       text-align: center;
       cursor: pointer;
       pointer-events: all;
       >p{
         width: 100%;
         height: 100%;
         line-height:60px;
         margin: 0;
       }
     }
     .active {
       background-color: rgba(65, 0, 153, 0.4);
     }
   }
 }
//  表格排行榜css
table.gridtable {
  width: 100%;
           font-family: verdana,arial,sans-serif;
         font-size:11px;
         color:#F5A871;
        border-collapse: collapse;
     }
     table.gridtable th {
        border-width: 1px;
        padding: 8px;
        text-align: center;
      }
      table.gridtable td {
          border-width: 1px;
          padding: 8px;
          text-align: center;
      }
      .table-bg {
        background: rgba(0, 255, 255, 0.1)
      }
 </style>
